{
  "advancededitor": {
    "Add entry": "Añadir entrada",
    "Duplicate": "Duplicar",
    "Image attached": "Imagen adjunta",
    "Inherit from wheel": "Heredar de rueda",
    "Not shown on the wheel": "No se muestra en la rueda",
    "Popup message": "Mensaje pop up",
    "Shown on the wheel": "Mostrado en la rueda",
    "Weight": "Peso"
  },
  "app": {
    "Ads": "Anuncios",
    "Click here to report an inappropriate ad": "Haga clic aquí para informar sobre un anuncio inapropiado.",
    "Click the Language menu": "Haz clic en el menú de la esquina superior derecha para cambiar al español.",
    "Close ad": "Anuncio cerrado",
    "Common questions about using the random name picker wheel": "Preguntas comunes sobre el uso de la rueda selectora de nombres aleatorios",
    "Copy this wheel": "Copia esta rueda",
    "Create your own": "Crea tu propio",
    "Error": "Error",
    "Free and easy to use": "Gratis y fácil de usar. Utilizado por profesores y para sorteos. Ingrese los nombres y gire la rueda para elegir un ganador al azar. Personaliza la apariencia, guarda y comparte ruedas.",
    "Frequently Asked Questions": "Preguntas frecuentes",
    "It looks like you are using Internet Explorer": "Parece que está utilizando Internet Explorer. Ese navegador pronto dejará de recibir actualizaciones de seguridad de Microsoft. Esto lo pone a usted y a nosotros en un gran riesgo.\nPróximamente no podrá utilizar este sitio web con Internet Explorer. Descargue otro navegador realizando una búsqueda en línea de \"descargar navegador web\". Cualquier navegador moderno servirá, por ejemplo, Chrome, Firefox o Edge.",
    "Loaded default names and options": "Utilizar nombre y opciones predeterminados",
    "Random name picker": "Selector de nombre aleatorio",
    "Removed": "{name} ha sido suprimido",
    "Removing winner in": "Eliminando al ganador en {seconds} segundos",
    "Report bad ad": "Informar mal anuncio",
    "Warning": "Advertencia",
    "We try to display only legitimate and honest ads": "Intentamos mostrar solo anuncios legítimos y honestos.",
    "authError": "Eso no funcionó. Intente nuevamente y se le pedirá que inicie sesión. Si aún no funciona, intente lo siguiente: actualice la página con Ctrl + Shift + R (Windows, Linux, Chromebook) o Command + Shift + R (Mac), apague su bloqueador de anuncios, apague su software antivirus. \n\n({error})"
  },
  "faq": {
    "How do I use this app": "¿Cómo uso esta aplicación?",
    "This app lets you spin a wheel": "Esta aplicación te permite girar una rueda",
    "Can I save my wheel": "¿Puedo guardar mi rueda?",
    "Yes, if you create an account": "Sí, si creas una cuenta",
    "Is this app free": "¿Es gratuita esta aplicación?",
    "Yes, this app is completely free": "Sí, esta aplicación es completamente gratuita"
  },
  "appInfo": {
    "Terms of service": "Términos de servicio",
    "Version": "Versión"
  },
  "common": {
    "Cancel": "Cancelar",
    "Close": "Cerrar",
    "Continue": "Continuar",
    "Customize": "Personalizar",
    "Delete": "Borrar",
    "Edit description": "Editar Descripción",
    "Edit title": "Editar Título",
    "Edit title and description": "Editar título y descripción",
    "If you dont see a Google login button below": "Si no ve un botón de inicio de sesión de Google a continuación, probablemente se deba a que está utilizando un bloqueador de anuncios que piensa erróneamente que el botón es un anuncio.",
    "Link Google Account": "Vincular cuenta de Google",
    "Link Google Sheet": "Vincular hoja de Google",
    "Link Google Spreadsheet": "Vincular a hoja de cálculo de Google",
    "My account": "Mi cuenta",
    "OK": "OK",
    "Open": "Abrir",
    "Privacy policy": "Privacidad",
    "Report offensive content": "Informar contenido ofensivo",
    "Save": "Guardar",
    "Sign in with Google": "Iniciar sesión con Google",
    "Sign in": "Iniciar sesión",
    "Create account": "Crear cuenta",
    "or": "o",
    "Email": "Correo electrónico",
    "Password": "Contraseña",
    "Display name": "Nombre para mostrar",
    "Display name is required": "El nombre para mostrar es obligatorio",
    "Sign in instead": "Iniciar sesión en su lugar",
    "Use this in the classroom": "Usa esto en el aula",
    "We have a winner!": "¡Tenemos un ganador!",
    "Wheel description": "Descripción de la rueda",
    "Wheel title": "Título de la rueda",
    "Max": "Máx",
    "Move down": "Mover abajo",
    "Move up": "Mover arriba"
  },
  "nameTabs": {
    "Clear the list": "Limpiar la lista",
    "Entries": "Entradas",
    "Hide": "Encubrir",
    "Results": "Resultados"
  },
  "opendialog": {
    "Are you sure": "¿Estás seguro de querer borrar \"{wheelTitle}\"? Esta acción no se puede deshacer.",
    "Delete wheel": "Borrar rueda",
    "No wheels found": "No se encontraron ruedas en su cuenta. ¡Intenta guardar una rueda!",
    "Open wheel": "Abrir rueda",
    "To open wheels": "2. Para abrir ruedas tienes que haber iniciado sesión con una cuenta.\nPor favor elige tu método de inicio de sesión entre los siguientes."
  },
  "optionsdialog": {
    "Options": "Opciones",
    "After spin": "Al dejar de girar",
    "All names in the text-box": "Todos los nombres en el cuadro de texto tienen la misma posibilidad de ganar, independientemente de este valor.",
    "Animate winning entry": "Animar el nombre ganador",
    "Appearance": "Apariencia",
    "Apply a theme": "Aplicar un tema",
    "Auto-remove winner after 5 seconds": "Remover automáticamente el nombre del ganador después de 5 segundos",
    "Background color": "Color de fondo de la página",
    "Center text": "Texto en el centro",
    "Colors": "Colores",
    "Colors tooltip": "Haga clic en las muestras de color para modificarlas.",
    "Contours": "Contornos",
    "Custom": "Personalizada",
    "Customize colors": "Personalizar colores",
    "Disabled because the entries": "Deshabilitado porque las entradas tienen pesos desiguales",
    "Display Hide button": "Mostrar el botón \"Ocultar\"",
    "Display Remove button": "Mostrar el botón \"Eliminar\"",
    "Display duplicates": "Mostrar duplicados",
    "Display every entry": "Muestra cada entrada en el cuadro de texto como una entrada en la rueda, incluso duplicados",
    "Display popup with message:": "Mostrar ventana emergente con el mensaje:",
    "During spin": "Rueda girando",
    "From Gallery": "De galería",
    "Image": "Imagen",
    "Image in the center of the wheel": "Imagen central de la rueda",
    "Image size": "Tamaño de la imagen",
    "Launch confetti": "Lanzar confeti",
    "Max names on wheel": "Cantidad máxima de nombres en la rueda",
    "No": "No",
    "One color": "Un color por sección",
    "Pick category": "Elegir una categoría",
    "Pick theme": "Elegir un tema",
    "Play click sound when the winner is removed": "Reproduce un sonido de clic cuando se elimina al ganador",
    "Remove image": "Quitar la imagen",
    "Select a gallery picture": "Seleccione una imagen de la galería",
    "Show title": "Mostrar título",
    "Sound": "Sonar",
    "Spin slowly": "Girar lentamente",
    "Spin time (seconds)": "Tiempo girando (segundos)",
    "Text": "Texto",
    "Upload image": "Subir imagen",
    "Volume": "Volumen",
    "Wheel background image": "Imagen de fondo de la rueda",
    "Yes": "Si",
    "Your image has been uploaded": "Su image '{fileName}' se ha cargado correctamente. ¿Le gustaría utilizar los colores destacados de esta imagen para los sectores de su rueda?",
    "Advanced mode is enabled": "El modo avanzado está habilitado",
    "Sounds": "Sonidos",
    "Behavior": "Comportamiento",
    "Effects": "Efectos",
    "Color": "Color"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "¿Estás seguro de que deseas eliminar tu cuenta y todas tus ruedas guardadas? Esta acción no se puede deshacer.",
    "Delete account": "Borrar cuenta",
    "Delete my account": "Borrar mi cuenta",
    "Export my data": "Exportar mis datos",
    "Sign out": "Terminar sesión",
    "Signed out": "Sesión cerrada",
    "Signed in as": "Has iniciado sesión como {name}",
    "Anonymous user": "Usuario anónimo",
    "Welcome new user": "¡Bienvenido a Spin the Names! Tu cuenta ha sido creada.",
    "Signed in success": "¡Sesión iniciada con éxito!",
    "Your account and your saved wheels have been deleted": "Su cuenta y sus ruedas guardadas han sido eliminadas"
  },
  "savedialog": {
    "Save as": "Guardar como",
    "Save wheel": "Guardar rueda",
    "Select a wheel": "Seleccionar una rueda",
    "Sorry, too many images": "Lo siento, esta rueda contiene demasiadas imágenes y no puede ser guardada.  Por favor reduce el número de imágenes e intenta nuevamente guardarla.",
    "To save wheels": "Para grabar ruedas necesitas haber iniciado sesión con una cuenta.\nPor favor elije tu método de inicio de sesión de los siguientes.",
    "Wheel saved successfully": "La rueda \"{wheelTitle}\" ha sido guardada",
    "You will always be able to access": "Siempre podrá acceder a sus ruedas guardadas siempre que abra o guarde cualquier rueda al menos una vez cada 12 meses.",
    "Your existing wheels": "Tus ruedas guardadas"
  },
  "sharedialog": {
    "Copy link": "Copiar vínculo",
    "Created": "creado",
    "If you continue": "Si continúa, creará un enlace público a su rueda actual, incluidos sus nombres, colores y configuraciones.",
    "Last viewed": "Visto por última vez",
    "Link": "Enlazar",
    "Link copied to the clipboard": "Enlace copiado en el portapapeles",
    "Link to this wheel": "2. Vínculo para compartir esta rueda incluyendo nombres, colores y ajustes:",
    "My shared wheels": "Mis ruedas compartidas",
    "No wheels found": "No se encontraron ruedas compartidas en su cuenta. ¡Intenta compartir una rueda!",
    "See my shared wheels": "Mira mis ruedas compartidas",
    "Shareable link": "Compartir vínculo",
    "Show title to people": "Muestre el título a las personas que usan su enlace compartido",
    "Sorry, too many images": "Lo siento, esta rueda contiene demasiadas imágenes para poder ser compartida.  Por favor reduce el número de imágenes e intenta nuevamente compartirla.",
    "They should be able to spin the wheel and": "Deberían poder hacer girar la rueda y hacer una copia de ella",
    "They should only be able to spin the wheel": "Solo deberían poder girar la rueda",
    "This link will work for anyone": "Este enlace funcionará para cualquier persona y puede compartirlo por correo electrónico, sitio web, redes sociales, etc. Los enlaces no utilizados se eliminarán después de 365 días.",
    "Visits": "Visitas",
    "We want this website to be safe place for everyone": "Queremos que este sitio web sea un lugar seguro para todos. Se eliminarán las ruedas que no sean aptas para familias y que violen los términos del servicio.",
    "What should a person be able to do": "¿Qué debe poder hacer una persona cuando usa su enlace compartido?"
  },
  "sheetdialog": {
    "Column": "Columna",
    "First row": "Primer fila",
    "Is a header and should not be imported": "Es un encabezado y no debe importarse",
    "Link sheet": "Vincular hoja de cálculo",
    "Select a column": "Selecciona una columna",
    "Select a tab": "Selecciona un tabulador",
    "Selected spreadsheet": "Hoja de cálculo seleccionada",
    "Tab": "Tabulador",
    "To import sheets": "Para importar hojas de cálculo debe iniciar sesión en tu cuenta de Google. ¿Por qué? Google necesita saber quién eres para poder elegir una de tus hojas de cálculo.",
    "When you link a spreadsheet": "Cuando vincules una hoja de cálculo, la rueda contendrá las mismas entradas que la hoja de cálculo. Si se agregan o eliminan filas en la hoja de cálculo, las entradas se agregan y eliminan automáticamente de la rueda. La conexión se cerrará después de una hora.",
    "added": "{entry} ha sido agregado",
    "entries added": "{count} nombres agregados"
  },
  "sounds": {
    "Alarm clock": "Despertador",
    "Angel choir": "Coro de ángeles",
    "Announcement bell": "Campana de anuncio",
    "Applause": "Aplauso estrepitoso",
    "Basketball buzzer": "Zumbador de baloncesto",
    "Bell ringing": "Campana sonando",
    "Bird chirps": "El pájaro gorjea",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Grito de carnaval",
    "Cartoon whistle": "Silbato de dibujos animados",
    "Cat meow": "Maullido de gato",
    "Childrens hooray": "Hurra de los niños",
    "Cinematic drum impact": "Impacto de tambor cinematográfico",
    "Cinematic music": "Música cinematográfica",
    "Correct answer ding": "Respuesta correcta ding",
    "Crash": "Choque",
    "Cymbals": "Platillos",
    "Dog bark": "Ladrido de perro",
    "Drum roll": "Redoble de tambor",
    "Easy listening": "Fácil escucha",
    "Evil laugh": "Risa malvada",
    "Fanfare": "Trompeteo",
    "Fireworks": "Fuegos artificiales",
    "Game win ding": "Ganar juego",
    "Ghost": "Fantasma",
    "Hooray": "Hurra",
    "Horror scream": "Grito de terror",
    "Horse": "Caballo",
    "Joke punchline": "Chiste",
    "Lion roar": "rugido de leon",
    "Lost game": "Juego perdido",
    "Microwave ding": "Ding de microondas",
    "Military trumpet": "Trompeta militar",
    "Mystery bell": "Campana misteriosa",
    "No sound": "Sin sonido",
    "Notification bell": "Campana de notificación",
    "Old phone ringing": "Viejo teléfono sonando",
    "Pan flute": "Flauta de pan",
    "Pop music": "Música pop",
    "Random 8-Bit": "8 bits aleatorios",
    "Random ballroom dancing": "Baile de salón al azar",
    "Random cinematic music": "Música cinematográfica aleatoria",
    "Random dance & techno": "Danza aleatoria y techno",
    "Random disco": "Discoteca aleatoria",
    "Random easy listening": "Escucha sencilla aleatoria",
    "Random electronica": "Electrónica aleatoria",
    "Random folk music": "Música folclórica aleatoria",
    "Random funk": "Funk aleatorio",
    "Random hip hop": "Hip hop al azar",
    "Random music": "Música aleatoria",
    "Random polka": "Polca al azar",
    "Random pop music": "Música pop aleatoria",
    "Random reggae & reggaeton": "Reggae y reggaeton aleatorios",
    "Random retro-rock": "Retro-rock aleatorio",
    "Random rock music": "Música rock aleatoria",
    "Random rockabilly": "Rockabilly aleatorio",
    "Random silent film score": "Partitura aleatoria de películas mudas",
    "Random winter holidays": "Música aleatoria de vacaciones de invierno",
    "Random world music": "Música del mundo aleatoria",
    "Read out the winning name": "Lee el nombre ganador",
    "Read out the winning name (option 1)": "Leer el nombre ganador (opción 1)",
    "Read out the winning name (option 2)": "Leer el nombre ganador (opción 2)",
    "Referee whistle": "Silbato de árbitro",
    "Rock music": "La música rock",
    "Sad trombone": "Trombón triste",
    "Silent film score": "Banda sonora de cine mudo",
    "Sound effects": "Efectos de sonido",
    "Subdued applause": "Aplausos moderados",
    "Swoosh ding": "Swoosh ding",
    "Synth bell": "Campana de sintetizador",
    "Taiko drum": "Tambor taiko",
    "Thunder": "Trueno",
    "Ticking sound": "Sonido de tictac",
    "Twinkling star": "Estrella centelleante",
    "Water splash": "Salpicadura de agua",
    "Winter holidays": "Música de vacaciones de invierno",
    "Wolf howl": "Aullido de lobo",
    "World music": "Música del mundo",
    "Xylophone ascending": "Xilófono ascendente"
  },
  "spinningwheel": {
    "Click to spin": "Haga clic para girar",
    "Tap to spin": "Toca para girar",
    "or press ctrl+enter": "o presiona ctrl+enter"
  },
  "textboxbuttons": {
    "Add image": "Agregar imagen",
    "Advanced": "Avanzado",
    "Revert from advanced": "Revertir",
    "Reverting will reset": "Si vuelve del modo avanzado, es posible que pierda algunos colores. Estás seguro de que quieres continuar?",
    "Shuffle": "Barajar",
    "Sort": "Ordenar"
  },
  "toolbar": {
    "Add your language": "Agrega tu idioma",
    "Dark mode": "Modo oscuro",
    "Exit fullscreen": "Salir de pantalla completa",
    "FAQ": "FAQ",
    "Feedback": "Comentarios",
    "Fullscreen": "Pantalla completa",
    "Language": "Idioma",
    "More": "Más",
    "New": "Nueva",
    "Offline mode": "Modo fuera de línea",
    "Please enter your email address": "Por favor ingrese su dirección de correo electrónico para continuar",
    "Send debug data": "Enviar datos de depuración",
    "Share": "Compartir",
    "System theme": "Tema del sistema",
    "Theme settings": "Configuración de tema",
    "Light theme": "Tema claro",
    "Dark theme": "Tema oscuro",
    "Light": "Claro",
    "Dark": "Oscuro",
    "Currently using": "Actualmente usando",
    "Theme": "Tema",
    "Unlink Google Spreadsheet": "Desvincular hoja de cálculo de Google",
    "User reviews and tutorials": "Reseñas de usuarios y tutoriales",
    "Your session is now being recorded": "Su sesión ahora está siendo grabada. Puede detener la grabación cerrando la ventana de su navegador."
  },
  "winnerdialog": {
    "Hide": "Esconder",
    "Remove": "Suprimir",
    "Remove all instances": "Suprimir todas las instancias"
  },
  "banner": {
    "setupMessage": "¡Hola! Todavía estamos configurando todo. Algunas funciones pueden estar limitadas o temporalmente no disponibles. ¡Gracias por tu paciencia!",
    "dismissLabel": "Cerrar anuncio"
  },
  "accountdialog": {
    "Sign in intro": "Inicie sesión para guardar, compartir y administrar sus ruedas.",
    "Preparing sign-in": "Preparando opciones de inicio de sesión…",
    "Troubleshooting title": "Solución de problemas de inicio de sesión",
    "Login failed": "Error al iniciar sesión. Inténtalo de nuevo.",
    "Email verified": "Correo verificado",
    "Email not verified": "Correo no verificado",
    "Resend verification email": "Reenviar correo de verificación",
    "Verification email sent": "Correo de verificación enviado. Revisa tu bandeja de entrada y la carpeta de spam.",
    "Verification email failed": "Error al enviar el correo de verificación. Inténtalo de nuevo más tarde."
  }
}
